import axios from "axios";
import Token from "../jwt/Token.js";

export default class Storage extends Token {

  /*BAIXANDO UM ARQUIVO*/
  download(hashKey) {
    return axios({
      method: "get",
      url: this.api_storage + "file/download/" + hashKey,
      withCredentials: true,
      headers: {
        //Authorization: "Bearer " + this.token(),
      },
      responseType: "blob"
    });
  }
  /*UPDANDO UM ARQUIVO PARA DENTRO DE UM DIRETORIO*/
  upload(arquivo, folderId) {
    return axios({
      method: "post",
      url: this.api_storage + "file/upload?folder=" + folderId,
      withCredentials: true,
      data: { file: arquivo },
      headers: {
        //Authorization: "Bearer " + this.token(),
        'Content-Type': 'multipart/form-data'
      },
    });
  }
  /*ATUALIZANDO UM ARQUIVO DENTRO DE UM DIRETORIO
    PELO HASH DO ARQUIVO*/
  update(hashKey, arquivo) {
    return axios({
      method: "put",
      url: this.api_storage + "file/" + hashKey,
      withCredentials: true,
      data: { file: arquivo },
      headers: {
        //Authorization: "Bearer " + this.token(),
        'Content-Type': 'multipart/form-data'
      },
    });
  }
  /*REMOVENDO ARQUIVO DE DENTRO DE UM DIRETORIO PELO HASH*/
  remove(hashKey) {
    return axios({
      method: 'delete',
      url: this.api_storage + 'file/' + hashKey,
      withCredentials: true,
      headers: {
        //'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
  /*VIZUALIZANDO UM ARQUIVO OUTRA ABA*/
  previewFileToPage(hashKey) {
    window.open(`${this.api_storage}file/preview/${hashKey}`, '_blank');
  }
  /*VIZUALIZANDO UM ARQUIVO DE ACORDO COM A URL. ESPECIFICO PARA PDF, PNG, JPG E JPEG*/
  previewImg(hashKey) {
    if (hashKey === null || hashKey === "") {
      return;
    } else {
      return this.checkProviderImg(hashKey);
    }
  }

  checkProviderImg(param) {
    /* SE O PROVEDOR DA IMAGEM FOR O FIREBASE */
    if (param.includes("firebase")) {
      return param;
      /* SE O PROVEDOR DA IMAGEM FOR API DE STORAGE */
    } else {
      return `${this.api_storage}file/preview/${param}`
    }
  }

  searchDir() {
    let directors = {}; // Alterado para objeto e definido como let para reatribuição
    console.log(process.env.VUE_APP_ENV);
    switch (process.env.VUE_APP_ENV) {
      case "development":
        //console.log("DESENVOLVIMENTO");
        directors = {
          servicos: {
            key: "" /** USA DAS CREDENCIAIS DE DEV */
          },
          banners: {
            key: "" /** USA DAS CREDENCIAIS DE DEV */
          },
          servidores: {
            key: "" /** USA DAS CREDENCIAIS DE DEV */
          }
        };
        break;
      case "production":
        //console.log("Produção");
        directors = {
          servicos: {
            key: "F-2adb6da59-e919-475c-9b30-dad152861387"
          },
          banners: {
            key: "F-28121330f-64ca-435a-ad65-ef6a3bd34672"
          },
          servidores: {
            key: "F-2eb9769e0-21ea-49ad-9d4c-ab18fd55573c"
          }
        };
        break;
      case "staging":
        //console.log("Homologação");
        directors = {
          servicos: {
            key: "F-1ef86f362-2562-430a-9eba-da060c113680"
          },
          banners: {
            key: "F-1bc7d2d3a-3a22-49f6-a182-36e9b1001bed"
          },
          servidores: {
            key: "F-1c9ffadb7-c0f2-4a9e-8832-9a01d55a2b7a"
          }
        };
        break;
      case "training":
        //console.log("Treinamento");
        directors = {
          servicos: {
            key: ""
          },
          banners: {
            key: ""
          },
          servidores: {
            key: ""
          }
        };
        break;
      default:
        console.log("Ambiente não definido");
        break;
    }
    return directors;
  }

}